export const StoreConstants = {
  STORE_KEY: 'assessments',
};
